module.exports = __webpack_public_path__ + "img/ArrowLeft.984c0ff6.png";